import { createContext, useContext, useState } from "react";

// Desktop Multi-Pane Routing Shell state. `activeWorkspaceView` drives the
// right-hand contextual pane on md:+ desktops ('CONTROL_DECK' on Home). `shell`
// is a live handle the persistent left nav rail uses to drive the SAME view
// state AppShell owns — so desktop navigation never remounts the app (renders
// keep running server-side while the user switches panes).
const WorkspaceContext = createContext(null);

export const useWorkspace = () =>
  useContext(WorkspaceContext) || {
    activeWorkspaceView: "CONTROL_DECK",
    setActiveWorkspaceView: () => {},
    shell: null,
    setShell: () => {},
  };

export function WorkspaceProvider({ children }) {
  const [activeWorkspaceView, setActiveWorkspaceView] = useState("CONTROL_DECK");
  const [shell, setShell] = useState(null);
  return (
    <WorkspaceContext.Provider value={{ activeWorkspaceView, setActiveWorkspaceView, shell, setShell }}>
      {children}
    </WorkspaceContext.Provider>
  );
}
